import React from "react";
import { Interpolation } from "@emotion/serialize/dist/emotion-serialize.cjs";
import { Theme } from "@emotion/react";

export interface TabProps extends React.PropsWithChildren {
  label: string;
  extraCss?: Interpolation<Theme>;
}

const Tab: React.FC<TabProps> = (props) => {
  return <div css={[{ paddingTop: 16 }, props.extraCss]}>{props.children}</div>;
};

export default Tab;
